const _ = require('lodash');

module.exports = function (addressService, shopperService, deliveryService, $rootScope, moveFocus) {
    return {
        restrict: 'E',
        scope: {
            savedAddress: '=',
            addressSelected: '&',
            onAddNewaddress: '&',
            isSelectingBillingAddress: '=?',
            selectedKey: '=ngModel',
            canBeDelivered: '=?'
        },
        link($scope) {
            $scope.shopperService = shopperService;
            $scope.addressService = addressService;
            $scope.deliveryService = deliveryService;
            $scope.radio = { value: null };
            $scope.isLoadingSelectedAddress = false;
            $scope.serverErrorMsg = undefined;

            function setBillingAddress(addresses) {
                addressService.billingAddress = _.find(addresses, function (address) {
                    return address.IsBilling === true;
                });
            }

            $scope._init = function () {
                addressService.getSavedAddresses().then(function (result) {
                    if (result && addressService.savedAddresses.length > 0) {

                        $scope.savedAddress = _.last(addressService.savedAddresses);

                        setBillingAddress(result);

                        if (!$scope.isSelectingBillingAddress.mode) {
                            //Select the last saved address
                            $scope.radio.value = addressService.savedAddress.AddressId;
                        } else {
                            //Select current billing address
                            $scope.radio.value = addressService.billingAddress.AddressId;
                        }
                    }

                    moveFocus('.savedAddress-items .olyDropdown-link:first');
                });
            };

            function updateAddress() {
                $rootScope.$broadcast('address-update');
                $scope.radio.value = addressService.savedAddress.AddressId;
                $scope.addressSelected();
                $scope.isLoadingSelectedAddress = false;
            }

            $scope.selectAddress = function (addr) {
                $scope.isLoadingSelectedAddress = true;
                $scope.serverErrorMsg = undefined;

                if (addr != null && addr.AddressId !== 'n/a') {
                    if (!$scope.isSelectingBillingAddress.mode) {
                        $scope.savedAddress = addr;
                        addressService.saveSelectedSavedAddress(addr).then(function () {
                            updateAddress();
                        }, function(error) {
                            $scope.isLoadingSelectedAddress = false;
                            $scope.serverErrorMsg = error.data.ResponseStatus.Message;
                        });
                    } else {
                        addressService.setBillingAddress(addr.AddressId).then(function () {
                            addressService.billingAddress = addr;
                            $scope.addressSelected();

                            $scope.radio.value = addressService.billingAddress.AddressId;

                            $scope.isLoadingSelectedAddress = false;
                        }, function(error){
                            $scope.isLoadingSelectedAddress = false;
                            $scope.serverErrorMsg = error.data.ResponseStatus.Message;
                        });

                    }

                }
            };

            $scope.addAddress = function () {
                $scope.onAddNewaddress();
                $rootScope.$broadcast('checkout:is-adding-new-address');
            };

            $scope.goToTime = function () {
                $rootScope.$broadcast('savedAddress:canceled');
            };

            $scope.$on('address-modeChanged', function (e, args) {
                args = args || {};

                if (args.mode === 'existing') {
                    $scope._init();
                }
            });

            $scope.$on('login:success', function () {
                $scope._init();
            });

            $scope._init();
        },
        template: require('./saved-address-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/address/saved-address-directive.js
 **/